import { API } from 'aws-amplify'

/**
 * Fetches items from a GraphQL API in portions due to response size limitations.
 *
 * This function will keep fetching data in a loop until all items are retrieved,
 * using the `nextToken` to paginate through the data.
 *
 * @param {Object} queries - An object containing GraphQL queries.
 * @param {string} queryKey - The key to identify the specific query to be used from the queries object.
 * @param {Object} variables - An object containing the variables required for the GraphQL query.
 * @param {Object} [variables.nextToken] - The pagination token for fetching the next set of results.
 * @returns {Promise<Array>} A promise that resolves to an array of items retrieved from the GraphQL API.
 */
export const getAllTableItems = async (queries, queryKey, variables) => {
  let nextToken = null
  let loading = true
  const items = []

  /* Due to graphql response's size limitations we need to grab records in a while loop */
  while (loading) {
    const response = await API.graphql({
      query: queries[queryKey],
      variables: {
        ...variables,
        nextToken,
      },
    })

    nextToken = response.data[queryKey].nextToken

    if (nextToken === null) {
      loading = false
    }

    items.push(...response.data[queryKey].items)
  }

  return items
}
